export const UiReducer = function () {};

const uiInitialState = {
  miniCartIsOpen: false,
  miniCartSuccessIsOpen: false,
  checkoutPanelLoading: false,
  rootLoading: true,
  discount: {
    message: {},
    loading: {
      type: null,
      value: false,
    },
  },
  showFormByName: null,
  showSearchDropdown: false,
};

UiReducer.handleAction = (globalState = uiInitialState, action) => {
  switch (action.type) {
    case 'UI.miniCartToggle':
      return {
        ...globalState,
        miniCartIsOpen: action.data,
      };
    case 'UI.miniCartSuccessToggle':
      return {
        ...globalState,
        miniCartSuccessIsOpen: action.data,
      };
    case 'UI.faqPopupToggle':
      return {
        ...globalState,
        faqPopupIsOpen: action.data,
      };
    case 'UI.setCheckoutPanelLoading':
      return {
        ...globalState,
        checkoutPanelLoading: action.data,
      };
    case 'UI.rootLoading':
      return {
        ...globalState,
        rootLoading: action.data,
      };
    case 'UI.discountMessageUpdate':
      return {
        ...globalState,
        discount: {
          ...globalState.discount,
          message: action.data,
        },
      };
    case 'UI.discountUpdateLoading':
      return {
        ...globalState,
        discount: {
          ...globalState.discount,
          loading: action.data,
        },
      };
    default:
  }

  return globalState;
};
